import React from 'react';
import { BallTriangle } from 'react-loader-spinner';


const Spinner = ({ message }) => {
  return(
    <div className='flex flex-col justify-center items-center w-full h-full'>
        <BallTriangle
            type="circles"
            color="#00BFFF"
            height={80}
            width={200}
            className='m-5 mb-10'
        />
        <p className="text-lg text-center px-2">{message}</p>
    </div>
)};

export default Spinner;
